import React from "react";
import clsx from "clsx";

import useStyles from "./styles";

interface IProps {
  className?: string;
}

const VerticalDivider = (props: IProps) => {
  const { className } = props;
  const classes = useStyles();

  return <div className={clsx(classes.divider, className)} />;
};

export default VerticalDivider;
